import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { round } from 'lodash';
import {
  CategoryTotalContainer,
  DescriptionBar,
  ValueBar,
  NumberCurrency,
  InputTitle,
  Spacer,
  InputContainer,
  InputPrefix
} from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';

const FmProductTotal = ({ price, onFeeChange, defaultAdditionalFee }) => {
  const [additionalOneTimeFee, setAdditionalOneTimeFee] = useState(
    defaultAdditionalFee
  );

  useEffect(() => {
    onFeeChange({
      additionalOneTimeFee: +additionalOneTimeFee || 0,
      onboardingFee: price
    });
  }, [price, additionalOneTimeFee]);

  return (
    <>
      <CategoryTotalContainer>
        <DescriptionBar>Monthly Managed IT Services Total</DescriptionBar>
        <ValueBar pos="right">
          Total Price: <NumberCurrency>{formatCurrency(price)}</NumberCurrency>
        </ValueBar>
      </CategoryTotalContainer>
      <Spacer />
      <InputTitle>Onboarding Fee</InputTitle>
      <input
        id="onboardingFee"
        name="onboardingFee"
        value={`$${price.toFixed(2)}`}
        disabled
        className="frg-input-field color-light"
        style={{ width: '100%' }}
      />
      <Spacer />
      <InputTitle>Additional Onboarding Fee</InputTitle>
      <InputContainer>
        <InputPrefix>$</InputPrefix>
        <input
          id="additionalOneTimeFee"
          name="additionalOneTimeFee"
          value={additionalOneTimeFee}
          type="number"
          className="frg-input-field color-light"
          style={{ width: '100%' }}
          onWheel={e => e.target.blur()}
          // onChange={e => {
          //   const inputValue = e.target.value;
          //   if (
          //     inputValue === '' ||
          //     (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
          //   ) {
          //     setAdditionalOneTimeFee(inputValue);
          //   }
          // }}
          onChange={e => setAdditionalOneTimeFee(e.target.value)}
        />
      </InputContainer>
    </>
  );
};

FmProductTotal.propTypes = {
  price: PropTypes.number.isRequired,
  onFeeChange: PropTypes.func.isRequired,
  defaultAdditionalFee: PropTypes.number.isRequired
};

export default FmProductTotal;
